<template>
    <BasePage>

        <template v-slot:menu>
            <SiteLogo />
        </template>

        <template v-slot:page-body>

            <div class="loader-container"
                 v-loading="controlLoading">
            </div>

            <router-view />

        </template>

    </BasePage>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import BasePage from './BasePage.vue'
import SiteLogo from '@/layout/SiteLogo.vue'

    export default defineComponent({
        components: {
            BasePage,
            SiteLogo
        },
        data(){
            return{
                controlLoading: true,
            }

        }
    })
</script>

<style class="scss" scoped>
    .loader-container {
        margin-top: 500px;
    }
</style>

